import { inject, Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { NamedRoute } from './route.constants';

/**
 * RouterService is a utility service for handling navigation within the application.
 * It provides methods for navigating to specific routes with enhanced functionality.
 *
 * This service will encapsulate the Angular routing mechanism, making it easier
 * to refactor in the future if Angular changes its router API.
 */
@Injectable({
    providedIn: 'root',
})
export class RouterService {
    private readonly router = inject(Router);

    navigateTo(route: NamedRoute<object>, extras?: NavigationExtras): Promise<boolean> {
        return this.router.navigate([route.path], {
            ...extras,
            queryParams: {
                ...route.parameters,
            },
        });
    }

    navigateAndReplaceUrl(route: NamedRoute<object>, extras?: NavigationExtras): Promise<boolean> {
        return this.navigateTo(route, {
            ...extras,
            replaceUrl: true,
            queryParams: {
                ...route.parameters,
            },
        });
    }
}
